import { apiSlice } from '../../../api/apiSlice';

// create a slice
export const importSetSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    /** @GET */
    getValidateFile: builder.query({
      query: payload =>
        `/import-set/validate-file/${payload.id.join(',')}`,
      transformResponse: res => res,
      transformErrorResponse: res => res,
    }),
    /** @GET */
    getLoadReport: builder.query({
      query: payload =>
        `/import-set/report/${payload.imported_file_id}`,
      transformResponse: res => res,
      transformErrorResponse: res => res,
    }),
    /** @POST */
    postLoadData: builder.mutation({
      query: payload => ({
        url: `/import-set/load-data/${payload.id.join(',')}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (result, error, arg) => [
        {
          type: 'Organization',
          id: arg.id,
        },
      ],
    }),
    /** @POST */
    importSetInitiate: builder.mutation({
      query: payload => ({
        url: '/import-set/initiate',
        method: 'POST',
        body: payload,
      }),
      providesTags: (result, error, arg) => [
        {
          type: 'Organization',
          id: 'LIST',
        },
        ...result.ids.map(id => ({
          type: 'Organization',
          id,
        })),
      ],
    }),
  }),
});

export const {
  usePostLoadDataMutation,
  useGetLoadReportQuery,
  useGetValidateFileQuery,
  useImportSetInitiateMutation,
} = importSetSlice;
